import React from 'react'
import { useSchedule } from '../../context/ScheduleContext'

const DayTypesFooter = ({ loading, submitData, }) => {
       const {selectedDayType } = useSchedule()
    
  return (
    <div className="tw-flex tw-items-center tw-justify-end tw-border-t tw-border-base-300 tw-px-4">
      <div className="tw-my-4 tw-flex tw-items-center tw-gap-3">
        <button
          disabled={loading}
          type="button"
          onClick={() => submitData()}
          className={`tw-cursor-pointer tw-rounded-lg tw-p-3 tw-text-sm tw-font-medium  hover:tw-opacity-80 ${selectedDayType ?'tw-bg-primary tw-text-white' : 'tw-bg-content-base/20 tw-text-content-base/60'}`}
        >
          Wybierz typ dnia
        </button>
      </div>
    </div>
  )
}

export default DayTypesFooter
